<template>
  <div class="check">
    <div class="banner flex a-c">
      <div class="title">
        <div>企业要闻</div>
        <div class="flex cubebox">
          <div>Business News</div>
        </div>
      </div>
    </div>
   <div class="flex flex-c">
     <div class="contentbox">
 <!-- 热力推荐 -->
    <div class="text-left">
      <div>热力推荐</div>
      <div class="english">Thermal recommended</div>
      <div class="flex hotbox">
       <div v-for="(item, index) in titleinfo" :key="index" class="recom">
         <img :src="item.cover" alt="" @click="artdetails(item.id)">
       </div>
      </div>
    </div>
    <div class="line">
      <div class="text-left industry">
         <div>行业资讯</div>
      <div class="english">Industry News</div>
      </div>
      <div
        v-for="(item, index) in articlelist"
        :key="index"
        class="articleitem flex"
        @click="artdetails(item.id)"
      >
        <div class="contentimg">
          <img :src="item.cover" alt="" />
         <!-- <div class="imgtitie">
          <p><span v-if="index<10">0</span>{{index+1}}</p>
           <p >{{ item.createTime }}</p>
         </div> -->
        </div>
        <div class="rightbox">
          <p class="mt20 titlecolor">{{ item.title }}</p>
          <p class="mt20 contenthidden">{{ item.content }}</p>
          <p class="mt20">{{ item.createTime }}</p>
        </div>
      </div>
      <div class="demo-pagination-block">
        <el-pagination
          v-model:current-page="currentPage"
          :page-size="5"
          layout=" prev, pager, next,total"
          :total="total"
          @current-change="handleCurrentChange"
          prev-text="上一页"
          next-text="下一页"
        />
      </div>
    </div>
    </div>
   </div>
   
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  getCurrentInstance,
} from "vue";
import { notesListApi } from "@/api/index.js";
let currentPage = ref(1);
onMounted(() => {
  getList();
});
// 跳转详情
const artdetails = (val) => {
  window.open(`https://www.laolesiyun.com/article?id=${val}`, "_blank");
};
// 获取文章列表
let articlelist = ref([]);
let titleinfo = ref([]);
let total = ref(0);
const getList = () => {
  notesListApi({ page: currentPage.value, limit: 5 })
    .then((res) => {
      articlelist.value = res.list[0].newNotesListResponseList;
      titleinfo.value = res.list[0].mainNotesResponse;
      total.value = res.total;
    })
    .catch((err) => {
      console.log(err);
    });
};
const handleCurrentChange = (val) => {  
  currentPage.value = val;
  getList()
};
</script>
<style scoped lang="scss">
.check {
  .demo-pagination-block{
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
  .banner {
    width: 100%;
    height: 210px;
    background-image: url("../../assets/about.png");
    background-size: 100% 100%;
    position: relative;
  }
  .title {
    color: #ffffff;
    font-size: 30px;
    position: absolute;
    left: 475px;
    font-weight: normal;
  }
  .cubebox {
    font-size: 25px;
  }
  .contanier {
    width: 80%;
    height: 500px;
    position: relative;
    margin-bottom: 50px;
  }
  .bannertxt {
    position: absolute;
    text-align: left;
    left: 20%;
    top: 20%;
    font-size: 24px;
    color: #333;
  }
  .activity {
    font-size: 20px;
    line-height: 50px;
  }
  .el-button {
    width: 155px;
    height: 50px;
    font-size: 20px;
    margin-top: 80px;
  }
  .line {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    cursor: pointer;
    margin-top: 50px;
  }
  .contentimg {
    width: 90px;
    height: 90px;
    margin-right: 30px;
    position: relative;
    img {
      height: 100%;
    }
  }
  .articleitem {
    width: 100%;
    margin: 20px 0;
    justify-content: center;
  }
  .rightbox {
    text-align: left;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #6b6b6b;
  }
  .mt20 {
    margin-bottom: 10px;
  }
  .titlecolor {
    // color: #333;
  }
  .bannerimg {
    height: 500px;
  }
}
.english{
  color: #b9b9b9;
  font-size: 15px;
}
.contentbox{
  width: 1200px;
  margin: 30px 0;

}
.text-left{
  text-align: left;
  font-size: 20px;
  width: 100%;
}
.imgtitie{
  position: absolute;
  top: 50%;
  left: 50%;
}
.industry{
  padding-bottom: 5px;
  border-bottom: 1px solid #eaeaea;
}
.recom{
  width: 33.3%;
  height: 200px;
  margin-right: 30px;
}
.recom:nth-child(3n) {
  margin-right: 0 ;
}
.hotbox{
  cursor: pointer;
  margin-top: 30px;
}
.contenthidden{
  width: 1080px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>